import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../../LoadingSlice";
import { fetchHealthParameterList } from "../HealthParameterList";
import { toast } from "react-toastify";

interface UpdateHealthDataState {
    UpdateHealthData: {
        load: boolean;
        data: [];
    };
}

export const UpdateHealthDataSlice = createSlice({
    name: "UpdateHealthData",
    initialState: {
        UpdateHealthData: {
            load: false,
            data: [],
        },
    } as UpdateHealthDataState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(UpdateHealthDataData.pending, (state: UpdateHealthDataState) => {
                state.UpdateHealthData.load = true;
            })
            .addCase(UpdateHealthDataData.fulfilled, (state: UpdateHealthDataState, action: any) => {
                state.UpdateHealthData.data = action.payload;
                state.UpdateHealthData.load = false;
            })
            .addCase(UpdateHealthDataData.rejected, (state: UpdateHealthDataState) => {
                state.UpdateHealthData.load = false;
            })
            .addCase(getHealthDataData.pending, (state: UpdateHealthDataState) => {
                state.UpdateHealthData.load = true;
            })
            .addCase(getHealthDataData.fulfilled, (state: UpdateHealthDataState, action: any) => {
                state.UpdateHealthData.data = action.payload;
                state.UpdateHealthData.load = false;
            })
            .addCase(getHealthDataData.rejected, (state: UpdateHealthDataState) => {
                state.UpdateHealthData.load = false;
            });
    },
});

export default UpdateHealthDataSlice.reducer;

export const UpdateHealthDataData = createAsyncThunk(
    "UpdateHealthData/UpdateHealthDataData",
    async (param: { apiParam: { probability_of_event: string, effect_of_event: string, element_pin: any, element_issue_pin: any, subissue_pin: any, code: any, warehouse_id: any, tpi_firm_id: any, action?: any, comment?: any, page: any, per_page: any, search: any }, navigation: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post("api/updateElementHealthData", {
                probability_of_event: param.apiParam.probability_of_event,
                effect_of_event: param.apiParam.effect_of_event,
                element_pin: param.apiParam.element_pin,
                element_issue_pin: param.apiParam.element_issue_pin,
                subissue_pin: param.apiParam.subissue_pin,
                warehouse_id: param.apiParam.warehouse_id, 
                code: param.apiParam.code,
                tpi_firm_id: param.apiParam.tpi_firm_id,
                default_action: param.apiParam.action,
                comment: param.apiParam.comment
            });

            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                thunkAPI.dispatch(fetchHealthParameterList({ apiParam: { code: param.apiParam.code, page: param.apiParam.page, per_page: param.apiParam.per_page, search: param.apiParam.search, element_pin: param.apiParam.element_pin, warehouse_id: param.apiParam.warehouse_id, tpi_firm_id: param.apiParam.tpi_firm_id } }));
            };

            thunkAPI.dispatch(toggleLoading());
            return data.data;
        } catch (error) {
            toast.error("Something went wrong!",{theme: "colored"});
        }
    }
);

export const getHealthDataData = createAsyncThunk(
    "UpdateHealthData/getHealthDataData",
    async (param: { apiParam: { element_pin: any, element_issue_pin: any, subissue_pin: any, warehouse_id: any, tpi_firm_id: any } }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post("api/getWarehouseHealthParameterData", {
                element_pin: param.apiParam.element_pin,
                element_issue_pin: param.apiParam.element_issue_pin,
                subissue_pin: param.apiParam.subissue_pin,
                warehouse_id: param.apiParam.warehouse_id, 
                tpi_firm_id: param.apiParam.tpi_firm_id,
            });

            thunkAPI.dispatch(toggleLoading());
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(toggleLoading());
        }
    }
);